import React from 'react';
import { GxZone } from '../../api/guestExperience';

export interface ZoneFilterBarProps {
  zones: GxZone[];
  selectedZones: string[];
  onToggleZone: (zoneId: string) => void;
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    padding: '0.5rem 0',
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px 12px',
    borderRadius: '16px',
    fontSize: '0.8rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    border: '2px solid',
    userSelect: 'none' as const,
  },
  allZonesLabel: {
    fontSize: '0.75rem',
    color: '#999',
    fontStyle: 'italic',
    display: 'flex',
    alignItems: 'center',
    padding: '6px 0',
  },
};

function getContrastColor(hexColor: string): string {
  // Remove # if present
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#000' : '#fff';
}

export function ZoneFilterBar({ zones, selectedZones, onToggleZone }: ZoneFilterBarProps) {
  const noneSelected = selectedZones.length === 0;

  return (
    <div style={styles.container}>
      {noneSelected && (
        <span style={styles.allZonesLabel}>All Zones</span>
      )}
      {zones.map((zone) => {
        const isSelected = selectedZones.includes(zone.id);
        const chipStyle: React.CSSProperties = isSelected
          ? {
              ...styles.chip,
              backgroundColor: zone.color,
              borderColor: zone.color,
              color: getContrastColor(zone.color),
            }
          : {
              ...styles.chip,
              backgroundColor: 'transparent',
              borderColor: zone.color,
              color: zone.color,
            };

        return (
          <button
            key={zone.id}
            style={chipStyle}
            onClick={() => onToggleZone(zone.id)}
            aria-pressed={isSelected}
            aria-label={`Filter by zone: ${zone.name}`}
          >
            {zone.name}
          </button>
        );
      })}
    </div>
  );
}
